var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "meta-nav grid grid__base", class: _vm.bemFacets },
    [
      _c("div", { staticClass: "meta-nav--container grid--container" }, [
        _c("div", { staticClass: "grid--row" }, [
          _c(
            "ul",
            { staticClass: "u-reset meta-nav--content grid--col" },
            [
              _c(
                "li",
                { staticClass: "meta-nav--item meta-nav--item__mobile" },
                [
                  _c("lang-switch", {
                    staticClass: "meta-nav--link meta-nav--lang-switch",
                    attrs: {
                      "current-lang": "de",
                      type: "inline",
                      languages: _vm.languages
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.links, function(item, idx) {
                return _c("li", { key: idx, staticClass: "meta-nav--item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "u-reset  meta-nav--link",
                      attrs: {
                        href: item.path,
                        target: item.external ? "_blank" : null
                      }
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                ])
              }),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "meta-nav--item meta-nav--item__desktop" },
                [
                  _c("lang-switch", {
                    staticClass: "meta-nav--lang-switch",
                    attrs: { languages: _vm.languages }
                  })
                ],
                1
              )
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-318cff10", { render: render, staticRenderFns: staticRenderFns })
  }
}